export default __webpack_public_path__ + "static/media/drupal-logo.ec1a695f.png";